module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/camera/camera.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/camera/camera.png
// module id = 526
// module chunks = 0